/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Event_Management20Inputs */

const en__field_enum_icsrm_event_management20 = /** @type {(inputs: _Field_Enum_Icsrm_Event_Management20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event, Tourism or Hospitality Management`)
};

const de__field_enum_icsrm_event_management20 = /** @type {(inputs: _Field_Enum_Icsrm_Event_Management20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event-, Tourismus- & Gastgewerbe-Management`)
};

/**
* | output |
* | --- |
* | "Event, Tourism or Hospitality Management" |
*
* @param {_Field_Enum_Icsrm_Event_Management20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_event_management20 = /** @type {((inputs?: _Field_Enum_Icsrm_Event_Management20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Event_Management20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_event_management20(inputs)
	return de__field_enum_icsrm_event_management20(inputs)
});
export { _field_enum_icsrm_event_management20 as "_field_enum_ICSRM_EVENT_MANAGEMENT" }